export default __webpack_public_path__ + "static/media/workwithus1.44a0d38e.jpg";